var exports = {
  "Qs": "x7f9a0e16--aca620--content",
  "EL": "x7f9a0e16--aca620--confirmation",
  "o6": "x7f9a0e16--aca620--resend",
  "z3": "x7f9a0e16--aca620--error",
};

module.exports = exports;
